import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-5 py-16 sm:py-24" data-id="element-162" data-mp="122vbicn8knnw">
      <div className="mx-auto max-w-3xl" data-id="element-163" data-mp="1prxupoxiqoki">
        <SectionHeading eyebrow="Frequently asked questions" title="Everything you need to know" data-id="element-164" data-mp="1pszechslojdu" />
        <div className="mt-10 space-y-3" data-id="element-165" data-mp="1uqiyfybzbqdp">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-brand-100" data-id="element-166" data-mp="1l17m82tsq5ll" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[16px] font-bold text-ink sm:text-lg" data-id="element-167" data-mp="28qjw74wy6hoy">
                  {f.q}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-168" data-mp="2jsp6717dcw97" />
                </button>
                <AnimatePresence initial={false} data-id="element-169" data-mp="37g72na1kwiii">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-170" data-mp="32hner43fcwni">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-ink-soft" data-id="element-171" data-mp="1n0loa9ajw6iy">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <CtaButton label="All clear — I want to start" className="mt-12" data-id="element-172" data-mp="27r8ydqdvrpth" />
      </div>
    </section>;
}